const setPointsOnMap = payload => {
  return {
    type: "setPointsOnMap",
    payload
  };
};
export default setPointsOnMap;
